import React from 'react';
import { Box, Typography } from '@mui/material';
import { broadcastStatusBgColors } from 'modules/broadcasts/constants';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { BroadcastStatus } from '@trnsact/trnsact-shared-types';

interface Props {
  status: BroadcastStatus;
}

export const StatusCell = ({ status }: Props) => {
  const classes = useStyles({ bgColor: broadcastStatusBgColors[status] });

  return (
    <Box className={classes.container}>
      <Typography align="center" component="span" variant="body2">
        {status}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme, { bgColor: string }>({
  container: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '70px',
    padding: '4px 10px',
    backgroundColor: ({ bgColor }) => bgColor,
  },
});
